// client/src/routes/app/settings/members.tsx — SCR-SET-004 · AUTH-006 (04 §8.18).
//
// The guard is `Org.ManageMembers` and not the `owner` role, because that permission is what
// the five endpoints behind this screen enforce (02 §6.4) and 03 §17.1 grants it to `owner`
// alone — the two are the same set, and the one that mirrors the API is the one that stays
// true if the seed ever changes. The tab in `settings/route.tsx` hides itself on the same
// reading; this is the other half of §9.2.2, for the URL that was typed anyway.

import { createFileRoute, redirect } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { staffRolesVisible } from '@/config/staff-roles';
import { MembersScreen } from '@/features/settings/MembersScreen';

export const Route = createFileRoute('/app/settings/members')({
  // Withdrawn from view with the accountant and the hired manager (D-2820): the screen exists
  // to invite them and show who holds each slot, so a typed or bookmarked address lands on the
  // settings area's first tab instead.
  beforeLoad: () => {
    if (!staffRolesVisible()) throw redirect({ to: '/app/settings/profile' });
  },
  component: MembersSettingsScreen,
});

function MembersSettingsScreen() {
  return (
    <RequirePermission permission="Org.ManageMembers">
      <MembersScreen />
    </RequirePermission>
  );
}
